import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-2 text-primary font-weight-medium" }

import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuantityChip',
  props: {
    modelValue: {},
    min: {},
    max: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const internalValue = ref(props.modelValue);
let interval: ReturnType<typeof setInterval> | null = null;
let holding = false;

watch(() => props.modelValue, (val) => {
  internalValue.value = val;
});

const changeValue = (delta: number) => {
  const newValue = internalValue.value + delta;
  if (newValue >= props.min && newValue <= props.max) {
    internalValue.value = newValue;
  }
};

const startIncreasing = () => {
  holding = true;
  changeValue(1);
  interval = setInterval(() => changeValue(1), 200);
};

const startDecreasing = () => {
  holding = true;
  changeValue(-1);
  interval = setInterval(() => changeValue(-1), 200);
};

const stopChanging = () => {
  if (holding) {
    clearInterval(interval!);
    holding = false;
    emit('update:modelValue', internalValue.value);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createBlock(_component_v_chip, {
    color: "accent",
    class: "pa-0 mt-1"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        icon: "",
        size: "x-small",
        variant: "text",
        color: "primary",
        onMousedown: startDecreasing,
        onMouseup: stopChanging,
        onMouseleave: stopChanging,
        onTouchstart: startDecreasing,
        onTouchend: stopChanging,
        disabled: __props.modelValue <= __props.min
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "x-small" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-minus", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"]),
      _createElementVNode("span", _hoisted_1, _toDisplayString(internalValue.value), 1 /* TEXT */),
      _createVNode(_component_v_btn, {
        icon: "",
        size: "x-small",
        variant: "text",
        color: "primary",
        onMousedown: startIncreasing,
        onMouseup: stopChanging,
        onMouseleave: stopChanging,
        onTouchstart: startIncreasing,
        onTouchend: stopChanging,
        disabled: __props.modelValue >= __props.max
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "x-small" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-plus", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})